import type { AuthedAxiosRequests } from 'features/auth'
import { fetchRolodexV3RolesAtScope } from 'features/permissions/utils/fetchRolodexV3RolesAtScope'
import {
  type ActiveScope,
  activeScopeFor,
} from 'features/permissions/utils/policyScopeEvaluation'
import useSWR from 'swr'

/**
 * `keepPreviousData` holds the last scope's roles while the next scope loads,
 * so callers must still check each role against the active scope.
 */
export function useRolodexV3RolesAtScope(
  axios: AuthedAxiosRequests,
  rolodexUrl: string,
  userId: string | undefined,
  authorization: string | undefined,
  active: ActiveScope | undefined
) {
  return useSWR(
    userId && rolodexUrl && authorization && active
      ? [
          rolodexUrl,
          userId,
          authorization,
          active.kind === 'root' ? undefined : active.orgId,
          active.kind === 'site' ? active.siteId : undefined,
        ]
      : null,
    ([url, id, , orgId, siteId]) =>
      fetchRolodexV3RolesAtScope(axios, url, id, activeScopeFor(orgId, siteId)),
    { keepPreviousData: true }
  )
}
